module.exports = __webpack_public_path__ + "img/keepkey.16f92fc8.svg";